/**
 * @generated SignedSource<<b7a85e7dafce1cfd490d8e093f10e7a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgreeTosPrivacyModalMutation$variables = {};
export type AgreeTosPrivacyModalMutation$data = {
  readonly agreeToTerms: {
    readonly userId: string | null;
  } | null;
};
export type AgreeTosPrivacyModalMutation = {
  response: AgreeTosPrivacyModalMutation$data;
  variables: AgreeTosPrivacyModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AgreeToTerms",
    "kind": "LinkedField",
    "name": "agreeToTerms",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgreeTosPrivacyModalMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AgreeTosPrivacyModalMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2b77a57a2d5aaee3eb6935de3b80720e",
    "id": null,
    "metadata": {},
    "name": "AgreeTosPrivacyModalMutation",
    "operationKind": "mutation",
    "text": "mutation AgreeTosPrivacyModalMutation {\n  agreeToTerms {\n    userId\n  }\n}\n"
  }
};
})();

(node as any).hash = "52740926e8cd29e32db06b20657392d0";

export default node;
